import { BaseTranscriptBlock } from './BaseTranscriptBlock';
import { useDiarizationCorrection } from '../hooks/useDiarizationCorrection';
import { LiveTranscriptBlock } from '../types/transcriptTypes';
import {
  Transcript,
  TranscriptBlock as BackendTranscriptBlock,
  TranscriptSpeaker,
} from '@/api/types/backend-dto-types';

interface TranscriptBlockProps {
  block: LiveTranscriptBlock | BackendTranscriptBlock;
  transcriptId?: string;
  caseId?: string;
  onAcceptCorrection?: (correctionId: string, blockId: string) => void;
  onRejectCorrection?: (correctionId: string, blockId: string) => void;
  // Editing props
  speakers?: TranscriptSpeaker[];
  onUpdate?: (blockId: string, content?: string, speakerId?: string | null) => void;
  isActive?: boolean;
  onClick?: () => void;
}

export const TranscriptBlock = ({
  block,
  transcriptId,
  caseId,
  onAcceptCorrection,
  onRejectCorrection,
  speakers,
  onUpdate,
  isActive = false,
  onClick,
}: TranscriptBlockProps) => {
  const { isProcessing, openPopoverId, handleAcceptCorrection, handleRejectCorrection, handlePopoverOpenChange } =
    useDiarizationCorrection({
      onAcceptCorrection,
      onRejectCorrection,
    });

  return (
    <BaseTranscriptBlock
      block={block}
      caseId={caseId}
      transcriptId={transcriptId}
      isActive={isActive}
      onClick={onClick}
      onAcceptCorrection={handleAcceptCorrection}
      onRejectCorrection={handleRejectCorrection}
      isProcessing={isProcessing}
      openPopoverId={openPopoverId}
      onPopoverOpenChange={handlePopoverOpenChange}
      speakers={speakers}
      onUpdate={onUpdate}
    />
  );
};
